import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vModelText as _vModelText, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-307fa997"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-page"
};
const _hoisted_2 = {
  class: "video-desc"
};
const _hoisted_3 = {
  key: 0,
  class: "flex flex-justify-between"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 0,
  class: "download-cover"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "down-icon",
  src: "https://video-h5.wqxsw.com/ttyd/image/down-icon.png",
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_7 = {
  class: "video-detail"
};
const _hoisted_8 = {
  class: "flex items-center flex-justify-between"
};
const _hoisted_9 = {
  class: "color-111 font-s18 font-w500"
};
const _hoisted_10 = {
  class: "flex items-center"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "color-555 fsl12"
};
const _hoisted_13 = {
  class: "desc-txt"
};
const _hoisted_14 = {
  class: "desc-pay"
};
const _hoisted_15 = {
  class: "line-one"
};
const _hoisted_16 = {
  class: "flex"
};
const _hoisted_17 = {
  key: 1,
  class: "flex"
};
const _hoisted_18 = {
  key: 0,
  class: "video-illustrate"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "推广说明", -1));
const _hoisted_20 = {
  class: "fsl15 flex flex-justify-between mt14"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-555"
}, "对标用户", -1));
const _hoisted_22 = {
  class: "color-111"
};
const _hoisted_23 = {
  class: "fsl15 flex flex-justify-between mt16"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-555"
}, "亮点集数", -1));
const _hoisted_25 = {
  class: "color-111"
};
const _hoisted_26 = {
  key: 1,
  class: "bg"
};
const _hoisted_27 = {
  class: "video-illustrate"
};
const _hoisted_28 = {
  class: "flex flex-justify-between"
};
const _hoisted_29 = {
  class: "fsl15 flex flex-justify-between mt14"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-555"
}, "网盘地址", -1));
const _hoisted_31 = {
  class: "color-111 line-one",
  style: {
    "width": "240px"
  }
};
const _hoisted_32 = {
  class: "fsl15 flex flex-justify-between mt16"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-555"
}, "提取码", -1));
const _hoisted_34 = {
  class: "color-111"
};
const _hoisted_35 = {
  key: 2,
  class: "flex media-tab"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "flex ask-tab"
};
const _hoisted_39 = {
  class: "video-illustrate"
};
const _hoisted_40 = {
  key: 0,
  class: "tab-item"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pop-box"
}, [/*#__PURE__*/_createElementVNode("p", null, "任务发布72小时"), /*#__PURE__*/_createElementVNode("p", null, "后，更新收益数据")], -1));
const _hoisted_42 = {
  style: {
    "padding-left": "5px"
  }
};
const _hoisted_43 = {
  class: "flex flex-justify-between proportion"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推广计划分成", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平台补贴分成", -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广告分成", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "任务介绍", -1));
const _hoisted_48 = {
  key: 0,
  class: "task-info"
};
const _hoisted_49 = {
  key: 1,
  class: "tab-item chart-tab"
};
const _hoisted_50 = {
  class: "title font-s16 color-111"
};
const _hoisted_51 = {
  class: "flex"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务名称", -1));
const _hoisted_53 = {
  class: "flex items-center"
};
const _hoisted_54 = {
  class: "color-2386FF"
};
const _hoisted_55 = {
  class: "flex"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务ID", -1));
const _hoisted_57 = {
  class: "flex items-center"
};
const _hoisted_58 = {
  class: "color-2386FF"
};
const _hoisted_59 = {
  class: "flex"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务地址", -1));
const _hoisted_61 = {
  class: "flex-column"
};
const _hoisted_62 = {
  class: "flex items-center"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://video-h5.wqxsw.com/ttyd/img/copy-icon.png",
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fsl12 color-999"
}, "复制此链接到浏览器再转抖音可直接打开", -1));
const _hoisted_65 = {
  class: "bottom-info flex-column items-center"
};
const _hoisted_66 = ["src"];
const _hoisted_67 = {
  key: 1,
  class: "none-qrcode"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://video-h5.wqxsw.com/ttyd/img/none-qrcode.png",
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_69 = [_hoisted_68];
const _hoisted_70 = {
  key: 2,
  class: "mt12 fsl13 color-555"
};
const _hoisted_71 = {
  key: 3,
  class: "flex mt12"
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "6px"
  }
}, null, -1));
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-555 fsl13"
}, "浏览器扫码接单任务", -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fsl11 color-555 mt16"
}, "挂载要求：粉丝≧1000人，星图任务数据在抖音星图查看", -1));
const _hoisted_75 = {
  key: 2,
  class: "tab-item chart-tab"
};
const _hoisted_76 = {
  class: "title font-s16 color-111"
};
const _hoisted_77 = {
  class: "title font-s16 color-111"
};
const _hoisted_78 = {
  class: "title font-s16 color-111"
};
const _hoisted_79 = {
  class: "title font-s16 color-111"
};
const _hoisted_80 = {
  class: "title font-s16 color-111"
};
const _hoisted_81 = {
  class: "title font-s16 color-111"
};
const _hoisted_82 = {
  class: "flex"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务名称", -1));
const _hoisted_84 = {
  class: "flex items-center"
};
const _hoisted_85 = {
  class: "color-2386FF"
};
const _hoisted_86 = {
  class: "flex"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务ID", -1));
const _hoisted_88 = {
  class: "flex items-center"
};
const _hoisted_89 = {
  class: "color-2386FF"
};
const _hoisted_90 = {
  class: "flex flex-justify-center"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-info flex-column items-center"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "fsl11 color-555 mt16"
}, "挂载要求：粉丝≧1000人，星图任务数据在抖音星图查看")], -1));
const _hoisted_92 = {
  key: 3,
  class: "tab-item"
};
const _hoisted_93 = {
  class: "flex items-center flex-justify-between"
};
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-s16 color-111 font-w500"
}, "充值分成", -1));
const _hoisted_95 = {
  class: "font-s18 color-2386FF font-w500"
};
const _hoisted_96 = {
  class: "push-content"
};
const _hoisted_97 = {
  class: "flex push-li items-center"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("计划名称")], -1));
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_100 = {
  class: "flex push-li items-center"
};
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("推广集数")], -1));
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_103 = {
  key: 0,
  class: "share-h5-box flex-column"
};
const _hoisted_104 = {
  style: {
    "height": "50px",
    "padding": "0 20px 20px"
  }
};
const _hoisted_105 = {
  class: "share-txt"
};
const _hoisted_106 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "ossfile"
}, null, -1));
const _hoisted_107 = {
  id: "container",
  class: "flex-column flex-justify-between"
};
const _hoisted_108 = {
  class: "share-btn",
  id: "selectfiles",
  href: "javascript:void(0);"
};
const _hoisted_109 = {
  class: "flex-column flex-justify-between",
  style: {
    "z-index": "99"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ttNavHeader = _resolveComponent("ttNavHeader");
  const _component_van_skeleton_image = _resolveComponent("van-skeleton-image");
  const _component_van_skeleton = _resolveComponent("van-skeleton");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popover = _resolveComponent("van-popover");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_van_progress = _resolveComponent("van-progress");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ttNavHeader, {
    title: "内容详情"
  }), _createElementVNode("div", {
    class: _normalizeClass(["content-page", {
      'app-active': $setup.isapp
    }])
  }, [_createElementVNode("div", _hoisted_2, [$setup.pageData.bookName ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    class: "cover-box",
    onClick: _cache[0] || (_cache[0] = $event => $setup.downloadCover($setup.pageData.coverWap))
  }, [_withDirectives(_createElementVNode("img", {
    src: $setup.pageData.coverWap,
    alt: "",
    srcset: ""
  }, null, 8, _hoisted_4), [[_vShow, $setup.pageData.coverWap]]), $setup.pageData.coverWap && $setup.isapp ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_hoisted_6, _createTextVNode("下载封面图 ")])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($setup.pageData.bookName), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    style: {
      "margin-right": "2px",
      "width": "20px !important",
      "height": "20px"
    },
    src: $setup.getCompanyInfo($setup.company_type, 'logo'),
    alt: ""
  }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, _toDisplayString($setup.getCompanyInfo($setup.company_type, 'name')), 1)])]), _createElementVNode("p", _hoisted_13, _toDisplayString($setup.pageData.introduction), 1), _withDirectives(_createElementVNode("p", _hoisted_14, [_createElementVNode("span", null, "免费集数：" + _toDisplayString($setup.pageData.freeNum) + "集", 1), _createElementVNode("span", _hoisted_15, "主角：" + _toDisplayString($setup.pageData.protagonist), 1)], 512), [[_vShow, $setup.pageData.freeNum]]), _withDirectives(_createElementVNode("ul", _hoisted_16, [_createElementVNode("li", null, "共" + _toDisplayString($setup.pageData.totalChapterNum) + "集", 1), _withDirectives(_createElementVNode("li", null, _toDisplayString($setup.pageData.payMoney) + "看点", 513), [[_vShow, $setup.pageData.payMoney]]), _createElementVNode("li", null, _toDisplayString($setup.pageData.sex == 1 ? "男频" : "女频"), 1)], 512), [[_vShow, $setup.pageData.totalChapterNum]])])])) : _createCommentVNode("", true), !$setup.pageData.bookName && !$setup.isOver ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_van_skeleton_image, {
    style: {
      background: '#fff',
      height: '120px'
    }
  }), _createVNode(_component_van_skeleton, {
    title: "",
    row: 3,
    style: {
      background: '#fff',
      padding: '10px',
      margin: '0 12px 14px',
      flex: 1,
      borderRadius: '6px'
    }
  })])) : _createCommentVNode("", true)]), $setup.pageData.hot_chapter ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("p", _hoisted_20, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString($setup.pageData.receiver), 1)]), _createElementVNode("p", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, "第" + _toDisplayString($setup.pageData.hot_chapter || 0) + "集", 1)])])) : _createCommentVNode("", true), !$setup.pageData.hot_chapter && !$setup.isOver ? (_openBlock(), _createElementBlock("div", _hoisted_26, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
    return _createVNode(_component_van_skeleton, {
      title: "",
      row: 4,
      style: {
        background: '#fff',
        padding: '10px',
        margin: '0',
        borderRadius: '6px'
      },
      key: i
    });
  }), 64))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_27, [_createElementVNode("h4", _hoisted_28, [_createTextVNode(" 素材提取 "), _createElementVNode("span", {
    class: "link-btn color-2386FF fsl12 font-w500",
    onClick: _cache[1] || (_cache[1] = $event => $setup.getContext('link')),
    style: {
      "margin-top": "-5px"
    }
  }, "获取")]), _createElementVNode("p", _hoisted_29, [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString($setup.pageData.net_disk), 1)]), _createElementVNode("p", _hoisted_32, [_hoisted_33, _createElementVNode("span", _hoisted_34, _toDisplayString($setup.pageData.pwd), 1)])], 512), [[_vShow, $setup.pageData.net_disk]]), $setup.pageData.admin_info.length ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pageData.admin_info, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["flex items-center flex-justify-center", {
        'active': $setup.mediaType == item.media
      }]),
      key: index,
      onClick: $event => $setup.changeMedia(item)
    }, [_createElementVNode("img", {
      src: $setup.mediaEnu[item.media + '-medialogo'],
      alt: "",
      srcset: ""
    }, null, 8, _hoisted_37), _createElementVNode("span", null, _toDisplayString($setup.mediaEnu[item.media + '-medianame']), 1)], 10, _hoisted_36);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_38, [$setup.mediaTask.tg_task && $setup.mediaTask.tg_task.task_id ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = $event => $setup.changeTab('mount')),
    class: _normalizeClass({
      'active': $setup.askTab == 'mount'
    })
  }, "小程序任务", 2)) : _createCommentVNode("", true), $setup.mediaTask.xt_task && $setup.mediaTask.xt_task.task_id ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    onClick: _cache[3] || (_cache[3] = $event => $setup.changeTab('chart')),
    class: _normalizeClass({
      'active': $setup.askTab == 'chart'
    })
  }, "星图任务", 2)) : _createCommentVNode("", true), $setup.mediaTask.rh_task && $setup.mediaTask.rh_task.task_id ? (_openBlock(), _createElementBlock("li", {
    key: 2,
    onClick: _cache[4] || (_cache[4] = $event => $setup.changeTab('mix')),
    class: _normalizeClass({
      'active': $setup.askTab == 'mix'
    })
  }, "融合任务", 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_39, [$setup.askTab == 'mount' && $setup.mediaTask.tg_task && $setup.mediaTask.tg_task.task_id ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("h4", null, [_createElementVNode("span", null, [_createTextVNode("分成比例"), _createVNode(_component_van_popover, {
    show: $setup.showPop,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showPop = $event),
    theme: "dark",
    class: "popover-def",
    placement: "bottom-start",
    onSelect: _cache[6] || (_cache[6] = $event => $setup.showPop = true)
  }, {
    reference: _withCtx(() => [_createElementVNode("span", _hoisted_42, [_createVNode(_component_van_icon, {
      name: "question-o",
      size: "16",
      color: "#111111"
    })])]),
    default: _withCtx(() => [_hoisted_41]),
    _: 1
  }, 8, ["show"])]), _createElementVNode("span", {
    class: "get-tag",
    style: _normalizeStyle({
      background: $setup.mediaTask.tg_task.task_settle_type == 1 ? '#824DFF' : '#FA1F0C'
    })
  }, _toDisplayString($setup.mediaTask.tg_task.task_settle_type == 1 ? "广告" : "支付") + "分成", 5)]), _createElementVNode("ul", _hoisted_43, [_createElementVNode("li", null, [_hoisted_44, _createElementVNode("span", null, _toDisplayString($setup.mediaTask.tg_task.payment_allocate_ratio) + "%", 1)]), _createElementVNode("li", null, [_hoisted_45, _createElementVNode("span", null, _toDisplayString($setup.mediaTask.tg_task.recharge_benefit) + "%", 1)]), _withDirectives(_createElementVNode("li", {
    style: _normalizeStyle({
      visibility: $setup.mediaTask.tg_task.task_settle_type == 1 ? 'hidden' : 'visible'
    })
  }, [_hoisted_46, _createElementVNode("span", null, _toDisplayString($setup.mediaTask.tg_task.ad_benefit) + "%", 1)], 4), [[_vShow, $setup.mediaTask.tg_task]])]), _hoisted_47, $setup.mediaTask.tg_task.task_desc ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mediaTask.tg_task.task_desc.split('\n'), (i, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, _toDisplayString(i), 1);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "fsl17 color-fff create-push",
    onClick: _cache[7] || (_cache[7] = $event => $setup.referralFn('tg'))
  }, "推广任务")])) : _createCommentVNode("", true), $setup.askTab == 'chart' && $setup.mediaTask.xt_task && $setup.mediaTask.xt_task.task_id ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("p", _hoisted_50, "星图结算分成比例：" + _toDisplayString($setup.mediaTask.xt_task.benefit), 1), _createElementVNode("ul", null, [_createElementVNode("li", _hoisted_51, [_hoisted_52, _createElementVNode("p", _hoisted_53, [_createElementVNode("span", _hoisted_54, _toDisplayString($setup.mediaTask.xt_task.task_name), 1), _createElementVNode("img", {
    src: "https://video-h5.wqxsw.com/ttyd/img/copy-icon.png",
    alt: "",
    srcset: "",
    onClick: _cache[8] || (_cache[8] = $event => $setup.copyToClipboard($setup.mediaTask.xt_task.task_name, '任务名称'))
  })])]), _createElementVNode("li", _hoisted_55, [_hoisted_56, _createElementVNode("p", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString($setup.mediaTask.xt_task.task_id), 1), _createElementVNode("img", {
    src: "https://video-h5.wqxsw.com/ttyd/img/copy-icon.png",
    alt: "",
    srcset: "",
    onClick: _cache[9] || (_cache[9] = $event => $setup.copyToClipboard($setup.mediaTask.xt_task.task_id, '任务ID'))
  })])]), _createElementVNode("li", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [_createElementVNode("p", _hoisted_62, [_createElementVNode("span", {
    class: "color-2386FF flex items-center",
    onClick: _cache[11] || (_cache[11] = function () {
      return $setup.openUrl && $setup.openUrl(...arguments);
    }),
    style: {
      "margin-right": "50px"
    }
  }, [_createTextVNode("访问 "), _createElementVNode("img", {
    src: "https://video-h5.wqxsw.com/ttyd/img/link-icon.png",
    alt: "",
    onClick: _cache[10] || (_cache[10] = function () {
      return $setup.openUrl && $setup.openUrl(...arguments);
    }),
    srcset: ""
  })]), _createElementVNode("span", {
    class: "color-2386FF flex items-center",
    onClick: _cache[12] || (_cache[12] = $event => $setup.copyToClipboard($setup.mediaTask.xt_task.task_url, '链接'))
  }, [_createTextVNode("复制 "), _hoisted_63])]), _hoisted_64])])]), _createElementVNode("div", _hoisted_65, [$setup.mediaTask.xt_task.qr_code ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "qr-code-img",
    onClick: _cache[13] || (_cache[13] = $event => $setup.downloadCover($setup.mediaTask.xt_task.qr_code)),
    src: $setup.mediaTask.xt_task.qr_code,
    alt: "",
    srcset: ""
  }, null, 8, _hoisted_66)) : (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69)), !$setup.mediaTask.xt_task.qr_code ? (_openBlock(), _createElementBlock("p", _hoisted_70, " 暂无图片")) : (_openBlock(), _createElementBlock("p", _hoisted_71, [_createElementVNode("span", {
    class: "color-2386FF fsl13",
    onClick: _cache[14] || (_cache[14] = $event => $setup.downloadCover($setup.mediaTask.xt_task.qr_code))
  }, "保存到相册"), _hoisted_72, _createTextVNode(), _hoisted_73])), _hoisted_74])])) : _createCommentVNode("", true), $setup.askTab == 'mix' && $setup.mediaTask.rh_task && $setup.mediaTask.rh_task.task_id ? (_openBlock(), _createElementBlock("div", _hoisted_75, [$setup.mediaTask.rh_task.pay_type == 17 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("p", _hoisted_76, "星图结算充值分成比例：" + _toDisplayString($setup.mediaTask.rh_task.task_benefit), 1), _createElementVNode("p", _hoisted_77, "星图结算广告分成比例：" + _toDisplayString($setup.mediaTask.rh_task.task_benefit), 1), _createElementVNode("p", _hoisted_78, "平台充值补贴分成比例：" + _toDisplayString($setup.mediaTask.rh_task.recharge_benefit), 1), _createElementVNode("p", _hoisted_79, "平台广告补贴分成比例：" + _toDisplayString($setup.mediaTask.rh_task.ad_benefit), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("p", _hoisted_80, "星图结算分成比例：" + _toDisplayString($setup.mediaTask.rh_task.task_benefit), 1), _createElementVNode("p", _hoisted_81, "平台补贴分成比例：" + _toDisplayString($setup.mediaTask.rh_task.recharge_benefit), 1)], 64)), _createElementVNode("ul", null, [_createElementVNode("li", _hoisted_82, [_hoisted_83, _createElementVNode("p", _hoisted_84, [_createElementVNode("span", _hoisted_85, _toDisplayString($setup.mediaTask.rh_task.task_name), 1), _createElementVNode("img", {
    src: "https://video-h5.wqxsw.com/ttyd/img/copy-icon.png",
    alt: "",
    srcset: "",
    onClick: _cache[15] || (_cache[15] = $event => $setup.copyToClipboard($setup.mediaTask.rh_task.task_name, '任务名称'))
  })])]), _createElementVNode("li", _hoisted_86, [_hoisted_87, _createElementVNode("p", _hoisted_88, [_createElementVNode("span", _hoisted_89, _toDisplayString($setup.mediaTask.rh_task.task_id), 1), _createElementVNode("img", {
    src: "https://video-h5.wqxsw.com/ttyd/img/copy-icon.png",
    alt: "",
    srcset: "",
    onClick: _cache[16] || (_cache[16] = $event => $setup.copyToClipboard($setup.mediaTask.rh_task.task_id, '任务ID'))
  })])]), _createElementVNode("li", _hoisted_90, [_createVNode(_component_van_button, {
    size: "normal",
    type: "primary",
    onClick: _cache[17] || (_cache[17] = $event => $setup.openDyApp($setup.mediaTask.rh_task.web_url))
  }, {
    default: _withCtx(() => [_createTextVNode("去抖音做任务")]),
    _: 1
  })])]), _hoisted_91])) : _createCommentVNode("", true), $setup.mediaTask.media != 'dy' ? (_openBlock(), _createElementBlock("div", _hoisted_92, [_createElementVNode("p", _hoisted_93, [_hoisted_94, _createTextVNode(), _createElementVNode("span", _hoisted_95, _toDisplayString(($setup.mediaTask.benefit || 0) * 100) + "%", 1)]), _createElementVNode("div", {
    class: "fsl17 color-fff create-push",
    onClick: _cache[18] || (_cache[18] = $event => $setup.referralFn('cj'))
  }, "创建推广")])) : _createCommentVNode("", true)])], 2), _createVNode(_component_van_action_sheet, {
    show: $setup.isShow,
    "onUpdate:show": _cache[22] || (_cache[22] = $event => $setup.isShow = $event),
    title: "创建推广"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_96, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_97, [_hoisted_98, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.name = $event),
      placeholder: "请输入计划名称(字数15个字以内)"
    }, null, 512), [[_vModelText, $setup.name]]), _hoisted_99])]), _createElementVNode("li", _hoisted_100, [_hoisted_101, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $setup.chapterIdx = $event),
      max: "10",
      placeholder: "推广剧集序号,例如1、2..."
    }, null, 512), [[_vModelText, $setup.chapterIdx]]), _hoisted_102])])]), _createElementVNode("span", {
      class: "push-confrim-btn",
      onClick: _cache[21] || (_cache[21] = function () {
        return $setup.confirm && $setup.confirm(...arguments);
      })
    }, "提交")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $setup.upshow,
    "z-index": "99"
  }, {
    default: _withCtx(() => [$setup.upshow ? (_openBlock(), _createElementBlock("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createElementVNode("p", _hoisted_105, _toDisplayString($setup.dyShareMsg || '请选择上传文件'), 1), _hoisted_106, _ctx.percentage > 0 ? (_openBlock(), _createBlock(_component_van_progress, {
      key: 0,
      color: "#FF3333",
      strokeWidth: 8,
      showPivot: false,
      percentage: _ctx.percentage
    }, null, 8, ["percentage"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_107, [_withDirectives(_createElementVNode("p", _hoisted_108, "选择文件", 512), [[_vShow, $setup.isFile]])]), _createElementVNode("div", _hoisted_109, [_createElementVNode("p", {
      class: _normalizeClass(["share-btn", {
        'share-success': $setup.dyShareOver,
        'share-loading': !$setup.dyShareOver
      }]),
      onClick: _cache[23] || (_cache[23] = _withModifiers(function () {
        return _ctx.closeFilePop && _ctx.closeFilePop(...arguments);
      }, ["stop"]))
    }, _toDisplayString($setup.dyShareMsg.indexOf('失败') > -1 ? '关闭' : '立即挂载'), 3)]), $setup.isFile ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "close",
      onClick: _cache[24] || (_cache[24] = $event => _ctx.closeFilePop('close'))
    }, [_createVNode(_component_van_icon, {
      name: "close",
      color: "#fff",
      size: "20"
    })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $setup.sheetShow,
    "onUpdate:show": _cache[25] || (_cache[25] = $event => $setup.sheetShow = $event),
    actions: [{
      name: '快手',
      value: 'kwai'
    }, {
      name: '快手极速版',
      value: 'ksnebula'
    }],
    "cancel-text": "取消",
    description: "请选择要挂载的快手",
    "close-on-click-action": "",
    onSelect: $setup.selectSheet,
    onCancel: _cache[26] || (_cache[26] = $event => $setup.sheetShow = false)
  }, null, 8, ["show", "onSelect"])]);
}